import { Component, Listen, Prop, Query, Watch } from '@atomify/core';
import { h } from '@atomify/jsx';
import { ModalWrapper } from '@atoms/modal-wrapper/modal-wrapper';
import { closeModal, modalStore, openModal } from '@source/store/modals';

import style from './iframe-modal.scss';

interface IframeModalData {
    close?: boolean;
}

@Component({
    tag: 'bpd-iframe-modal',
    style,
})
export class IframeModal extends HTMLElement {
    @Query('[js-hook-modal-wrapper-content]') modalWrapperContent: HTMLDivElement;

    @Prop() active: boolean = false;
    @Prop() src: string = '';
    @Prop() modalTitle: string = '';
    @Prop() minWidth = '100%';
    @Prop() minHeight = '50vh';
    @Prop() iframeId: string | undefined;
    @Prop({ type: 'String' }) classes: string = '';

    iframeCreated: boolean = false;

    componentWillLoad() {
        if (!this.id) throw new Error('[bpd-iframe-modal]: its mandatory to add an id');
    }

    componentDidLoad() {
        if (this.active) this.open();

        modalStore.subscribe(
            ({ modals }) => {
                const { active } = modals[this.id];
                this.active = active;
            },
            ['modals'],
        );
    }

    @Watch('active')
    open() {
        if (!this.iframeCreated) {
            const iframe = this.createIframe();
            this.modalWrapperContent.appendChild(iframe);
            this.iframeCreated = true;
        } else if (this.active) {
            openModal(this.id);
        }
    }

    @Listen('message', { target: window })
    iframeMessageReceived(e: MessageEvent) {
        const { data, modalId } = e.data;

        if (modalId === this.id) {
            this.runAction(data);
        }
    }

    runAction(data: IframeModalData) {
        const closeAction = data.close;
        if (closeAction) closeModal(this.id);
    }

    private createIframe() {
        const iframe = document.createElement('iframe');

        iframe.src = this.src;
        iframe.setAttribute('style', `min-width: ${this.minWidth}; min-height: ${this.minHeight};`);

        if (this.iframeId) {
            iframe.id = this.iframeId;
        }

        iframe.onload = () => {
            openModal(this.id);
        };

        return iframe;
    }

    render() {
        return (
            <div class={`bpd-iframe-modal__container ${this.classes}`}>
                <ModalWrapper id={this.id} active={false} title={this.modalTitle} />
            </div>
        );
    }
}
